import React from "react";

import { Button } from "@/components/Form";
import { LocaleProps, withLocale } from "@/i18n";
import { isMobilePhone } from "@/utils/getters";

import {
  ButtonWrap,
  ContentBox,
  Image,
  Section,
  Text,
  Title,
  Wrapper,
} from "./styles";

export type AnswerSlideProps = {
  answerText?: string;
  answerImage?: string;
  isCorrect?: boolean;
  onButtonClick?: () => void;
} & LocaleProps;

const AnswerSlide: React.FC<AnswerSlideProps> = (
  props: AnswerSlideProps
): JSX.Element => {
  const renderImage = (): JSX.Element => {
    // load always as small as possible images from images-service "dali" because of caching and speed
    const maxImageWidth = isMobilePhone() ? 480 : 560;
    const imageUrl = `${props.answerImage}?width=${maxImageWidth}`;
    return <Image src={imageUrl} showOnlyImage={!props.answerText} />;
  };

  return (
    <Section isCorrect={props.isCorrect}>
      <Wrapper>
        <Title>
          {props.isCorrect
            ? props.i18n?.answerSlide.correctAnswer
            : props.i18n?.answerSlide.wrongAnswer}
        </Title>
        <ContentBox>
          <Text>{props.answerText}</Text>
          {props.answerImage && renderImage()}
          <ButtonWrap>
            <Button onClick={props.onButtonClick}>
              {props.i18n?.answerSlide.next}
            </Button>
          </ButtonWrap>
        </ContentBox>
      </Wrapper>
    </Section>
  );
};

export default withLocale(AnswerSlide);
